import Step8 from './Step8-compose';

export default Step8;
